import React from "react";

const Footer = () => {
  return (
    <footer className="flex flex-col justify-center items-center bg-gradient-to-b from-gray-600 via-gray-500 to-gray-300 text-white font-sans py-4">
      <p>Sreatt batteries and Lubricant. All Rights Reserved.</p>
    </footer>
  );
};

export default Footer;
